<template>
  <div id="occurrence-column-chart">
    <apexchart :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: { apexchart: VueApexCharts },
  data: () => ({ }),
  props: ['occurrences', 'target', 'filename'],
  computed: {
    data() {
      if(!this.occurrences || this.occurrences.length == 0 || !this.target || this.target.length == 0) {
        return []
      }

      const reduced = this.occurrences.map(o => ({ 
        name: o[this.target.name],
        overdue: o.overdue
      })).reduce((acc, item) => {
        if (!acc[item.name]) {
            acc[item.name] = { onTime: 0, overdue: 0 };
        }
        if (item.overdue) {
            acc[item.name].overdue += 1;
        } else {
            acc[item.name].onTime += 1;
        }
        return acc;
      }, {})

      return reduced
    },
    series() {
      return [
        {
          name: this.$t('no-prazo'),
          data: Object.keys(this.data).sort().map(k => this.data[k].onTime)
        },
        {
          name: this.$t('em-atraso'),
          data: Object.keys(this.data).sort().map(k => this.data[k].overdue)
        },
      ]
    },
    chartOptions() {
      const self = this;
      return {
        colors:['#00909F', '#FF751B', '#4C999A', '#FF8E3C', '#7BA687', '#89FFDB'],
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: true
            },
            export: {
              csv: { filename: self.filename },
              png: { filename: self.filename },
              svg: { filename: self.filename },
            }
          },
        },
        legend: {
          position: 'left',
        },
        xaxis: {
          categories: Object.keys(this.data).sort(),
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return Math.round(val); // Arredonda para o número inteiro mais próximo
            }
          }
        },
      }
    },
    label() {
      return this.$t('quantidade')
    },
  }
}
</script>